import React, { useRef, useState } from "react";
import { Formik } from "formik";
import CMSFormInput from "../../formFields/CMSFormInput";
import CMSFormSelect from "../../formFields/CMSFormSelect";
import GeneralButton from "../../common/GeneralButton";
import ContainerLoading from "../../common/loading/ContainerLoading";
import { useToast } from "../../contexts/ToastContext";
import { childSchema } from "../../utils/validations";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { ref } from "yup";
import Icon from "../../common/Icon";
import { TiPlus } from "react-icons/ti";

const ChildListing = ({ children }) => {
  const navigate = useNavigate();
  return (
    <div className="mt-6 flex flex-col gap-6 bg-[#DEE2DD]/40 rounded-[15px] p-6 pb-10 lg:px-12 w-full relative">
      {/* Header */}
      <div className="flex items-center gap-4 mb-0">
        {/* <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 pe-3 py-2 bg-gray-200 rounded hover:bg-gray-300 transition"
        >
          <FiArrowLeft size={30} />
        </button> */}
        <p className="text-24pt">Child Listing</p>
      </div>

      {children.map((child, idx) => (
        <div
          key={idx}
          className="flex flex-col gap-6 bg-[#fff] rounded-[15px] py-4 px-4 md:px-6 relative"
        >
          <div
            className={`flex  flex-row items-center justify-between`}
            // onClick={() => navigate(`/account/subscriptions/${sub?._id}`)}
            // title={"Click to view details"}
          >
            <div className="flex items-center ">
              <div className="w-[76px] h-[76px] bg-white border border-[#DEE2DD] rounded-full flex items-center justify-center me-4 md:me-6 lg:me-6 relative">
                <Icon
                  icon="profile"
                  className={`w-[47px] h-[60px] ${
                    child.gender?.toLowerCase() === "girl"
                      ? "text-[#FC05B0]/40"
                      : "text-[#0B81FD]/40"
                  }`}
                />
              </div>

              <div>
                <p className="text-24pt leading-tight text-left">
                  {child.firstName} {child.lastName}
                </p>
                <p className="text-16pt mt-1 leading-tight text-left font-mono">
                  {child.gender} - {child.age} years old
                </p>
                <p className="text-12pt leading-tight text-left mt-1 text-orange">
                  {child.schoolName}
                </p>
              </div>
            </div>
            <div
              title="Click to edit child details"
              className="cursor-pointer"
              onClick={() =>
                navigate(`/account/profile/edit-child/${child?._id}`)
              }
            >
              <Icon
                icon="edit"
                className={`w-[27px] text-green hover:text-secondary`}
              />
            </div>
          </div>
        </div>
      ))}
      <div className="flex flex-col-reverse md:flex-row items-center justify-between  gap-5">
        <div></div>
        <GeneralButton
          onClick={() =>
                navigate(`/account/profile/add-child`)
              }
          text={"Add Child"}
          title="Click to add new child"
          type={"submit"}
          iconPosition="Right"
          textColor="#fff"
          icon={<TiPlus size={24} />}
          className="text-21pt px-4"
        />
      </div>
    </div>
  );
};

export default ChildListing;
